/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Samples_Ship_Dialog_DescriptionInputs */

const en_samples_ship_dialog_description = /** @type {(inputs: Samples_Ship_Dialog_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Add shipping details for ${i?.count} sample(s).`)
};

const es_samples_ship_dialog_description = /** @type {(inputs: Samples_Ship_Dialog_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Agregar detalles de envio para ${i?.count} muestra(s).`)
};

/**
* | output |
* | --- |
* | "Add shipping details for {count} sample(s)." |
*
* @param {Samples_Ship_Dialog_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_ship_dialog_description = /** @type {((inputs: Samples_Ship_Dialog_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_Ship_Dialog_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_ship_dialog_description(inputs)
	return es_samples_ship_dialog_description(inputs)
});